export interface RoutingPoi {
  placeId: string;
  name: string;
  lat: number;
  lng: number;
}

export function googleMapsDirectionsUrl(poi: RoutingPoi): string {
  const url = new URL('https://www.google.com/maps/dir/');
  url.searchParams.set('api', '1');
  url.searchParams.set('destination', `${poi.lat},${poi.lng}`);
  if (poi.placeId) {
    url.searchParams.set('destination_place_id', poi.placeId);
  }
  return url.toString();
}

export function appleMapsDirectionsUrl(poi: RoutingPoi): string {
  const url = new URL('https://maps.apple.com/');
  url.searchParams.set('daddr', `${poi.lat},${poi.lng}`);
  url.searchParams.set('q', poi.name);
  url.searchParams.set('dirflg', 'd');
  return url.toString();
}

/** Open the place in Google Maps. Uses the documented Maps URL API
 *  (`/search/?api=1&query=...&query_place_id=...`). The old
 *  `/place/?q=place_id:...` form stopped resolving in Google Maps
 *  ("no results") sometime in 2026. `query` is required by the
 *  Maps URL API even when `query_place_id` is set — we pass the
 *  POI name so the link still does something sensible if Maps
 *  can't resolve the placeId for any reason. */
export function googleMapsPlaceUrl(poi: RoutingPoi): string {
  const url = new URL('https://www.google.com/maps/search/');
  url.searchParams.set('api', '1');
  url.searchParams.set('query', poi.name);
  url.searchParams.set('query_place_id', poi.placeId);
  return url.toString();
}

/** Apple Maps "locate" URL — drops a pin on the place without launching
 *  directions. Used by the Route view when a single POI is in the route
 *  with no "here" stop ("show me where this is" instead of "route me"). */
export function appleMapsLocateUrl(poi: RoutingPoi): string {
  const url = new URL('https://maps.apple.com/');
  url.searchParams.set('ll', `${poi.lat},${poi.lng}`);
  url.searchParams.set('q', poi.name);
  return url.toString();
}
